// Copied from Tailwind's default transition
const transitionTimingFunction = 'cubic-bezier(0.4, 0, 0.2, 1)';

const textInputStyles = theme => ({
  '.text-input': {
    // Use box-shadow instead of border to avoid affecting overall size
    boxShadow: `inset 0px -1px ${theme('colors.green1.55')}`,
    boxSizing: 'border-box',
    color: theme('colors.black'),
    paddingBottom: '6px',
    '&:focus-within': {
      boxShadow: `inset 0px -2px ${theme('colors.green1.55')}`,
    },
    '.text-input-invalid &': {
      boxShadow: `inset 0px -2px ${theme('colors.alertred.60')}`,
    },
    '&.text-input-disabled': {
      color: theme('colors.grey.40'),
      boxShadow: `inset 0px -1px ${theme('colors.grey.25')}`,
    },
    '& input:disabled': {
      backgroundColor: 'transparent',
    },

    // Grey variant
    '&.grey': {
      color: theme('colors.grey.75'),
      boxShadow: `inset 0px -1px ${theme('colors.grey.25')}`,
    },
    '&.grey input::placeholder': {
      color: theme('colors.grey.75'),
    },
    '&.grey textarea::placeholder': {
      color: theme('colors.grey.75'),
    },
    '&.grey:focus-within': {
      boxShadow: `inset 0px -2px ${theme('colors.grey.25')}`,
    },
    '.text-input-invalid &.grey': {
      boxShadow: `inset 0px -2px ${theme('colors.alertred.60')}`,
    },
    '&.grey.text-input-disabled': {
      color: theme('colors.grey.40'),
      boxShadow: `inset 0px -1px ${theme('colors.grey.25')}`,
    },
  },

  '.text-input-contained': {
    boxShadow: `inset 0px 0px 0px 1px ${theme('colors.green1.55')}`,
    boxSizing: 'border-box',
    color: theme('colors.black'),
    borderRadius: '4px',
    padding: '10px',
    '&:focus-within': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.green1.55')}`,
    },
    '.text-input-invalid &': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.alertred.60')}`,
    },
    '&.text-input-disabled': {
      color: theme('colors.grey.40'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.grey.25')}`,
    },
    '& input:disabled': {
      backgroundColor: 'transparent',
    },

    // Grey variant
    '&.grey': {
      color: theme('colors.grey.75'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.grey.25')}`,
    },
    '&.grey input::placeholder': {
      color: theme('colors.grey.75'),
    },
    '&.grey textarea::placeholder': {
      color: theme('colors.grey.75'),
    },
    '&.grey:focus-within': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.grey.25')}`,
    },
    '.text-input-invalid &.grey': {
      boxShadow: `inset 0px 0px 0px 2px ${theme('colors.alertred.60')}`,
    },
    '&.grey.text-input-disabled': {
      color: theme('colors.grey.40'),
      boxShadow: `inset 0px 0px 0px 1px ${theme('colors.grey.25')}`,
    },
  },

  '.text-input-label': {
    transition: 'top 0.2s, left 0.2s, font-size 0.2s, font-weight 0.2s, padding 0.2s',
    transitionTimingFunction,
    color: theme('colors.green1.55'),
    '.text-input-invalid &': {
      color: theme('colors.alertred.60'),
    },

    // Grey variant
    '.grey &': {
      color: theme('colors.grey.45'),
    },
  },

  '.text-input-description': {
    transition: 'opacity 0.1s ease-in, height 0.1s ease-in, margin-top 0.1s ease-in',
    transitionTimingFunction,
    color: theme('colors.green1.55'),
    '.text-input-invalid &': {
      color: theme('colors.alertred.60'),
      opacity: '1',
    },

    // Grey variant
    '.grey &': {
      color: theme('colors.grey.45'),
    },
  },
});

module.exports = { textInputStyles };
